import GLU from '../glu2.js/src/index';

class S3Api extends GLU.Api {
  constructor(endpoint) {
    super(endpoint);

    this.createApiActions({
      name: 'sign',
      method: GLU.Api.Get,
      path: '/sign',
      credentials: true,
    });
  }
}

export default S3Api;
